import React from 'react'
import Chip, { ChipVariants } from 'core-system/Chip'
import { ProgramStatusType } from 'features/Programs/Shared/types'

const statusVariant = (status: ProgramStatusType): ChipVariants => {
  if (status === 'ACTIVE' || status === 'COMPLETE' || status === 'COMPLETED') {
    return 'green'
  }
  if (status === 'PENDING' || status === 'IN_PROGRESS') {
    return 'yellow'
  }
  if (status === 'ERROR' || status === 'ATTENTION_NEEDED') {
    return 'red'
  }
  if (status === 'UPDATING') {
    return 'blue'
  }
  if (status === 'BLOCKED') {
    return 'pink'
  }
  return 'grey'
}

const statusText = (status: ProgramStatusType) => {
  switch (status) {
    case 'ACTIVE':
      return 'Active'
    case 'PENDING':
      return 'Pending'
    case 'UPDATING':
      return 'Transitioning'
    case 'DRAFT':
      return 'Draft'
    case 'CANCELLING':
      return 'Cancelling'
    case 'BLOCKED':
      return 'Blocked'
    case 'COMPLETE':
      return 'Complete'
    case 'COMPLETED':
      return 'Completed'
    case 'NOT_STARTED':
      return 'Not Started'
    case 'IN_PROGRESS':
      return 'In Progress'
    case 'ERROR':
      return 'Error'
    case 'ATTENTION_NEEDED':
      return 'Attention Needed'
  }
}

interface StatusPillProps {
  status: ProgramStatusType
}

const StatusPill = ({ status }: StatusPillProps) => {
  return <Chip variant={statusVariant(status)}>{statusText(status)}</Chip>
}

export default React.memo(StatusPill)
